import * as React from "react";
import type { SVGProps } from "react";
const SkirtPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.914 5a.2.2 0 0 0-.2.2v2.171c0 .11.09.2.2.2h13.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2zm.01 3.429h13.72a.2.2 0 0 1 .195.158L21 18.714a28.46 28.46 0 0 1-18 0l1.728-10.12a.2.2 0 0 1 .197-.165" clipRule="evenodd" /></svg>;
export default SkirtPanelIcon;